

import {
  BackupDto,
  BackupId,
  BackupRepositoryInterface,
  RestoreBackupDto, WebsiteGroupRestoreBackupDto, WebsiteGroupRestoreBackupDtoExtended,
} from "@/services/Backup/interfaces";
import { Component, Prop } from "vue-property-decorator";
import Themeable from "vuetify/lib/mixins/themeable";
import WebsiteBackupsTable from "@/components/backups/WebsiteBackupsTable.vue";
import RestoreBackupDialog from "@/components/dialogs/backups/RestoreBackupDialog.vue";
import RestoreWebsiteGroupDialog from "@/components/dialogs/backups/RestoreWebsiteGroupDialog.vue";

@Component({
  components: { RestoreWebsiteGroupDialog, RestoreBackupDialog, WebsiteBackupsTable },
  mixins: [
    Themeable,
  ],
  inject: [
    'backupRepository',
  ]
})
export default class BackupDetails {
  @Prop({ required: true }) backupId!: BackupId;

  private readonly backupRepository: BackupRepositoryInterface;

  private backup: BackupDto | null = null;
  private isRestoreDialogVisible: boolean = false;
  private restoreDialogData: RestoreBackupDto | null;

  private isRestoreGroupDialogVisible: boolean = false;
  private restoreGroupDialogData: WebsiteGroupRestoreBackupDtoExtended | null;

  private scopeLabels = {
    'account': 'Terminated Backup',
    'server': 'Server Backup'
  };

  public actionStatusIconMap: { [key: string]: string } = {
    'scheduled': 'mdi-progress-clock',
    'pending': 'mdi-progress-helper',
    'failed': 'mdi-close-thick',
    'success': 'mdi-check',
  };

  public async fetchBackup(): Promise<void> {
    this.backup = await this.backupRepository.getBackup(this.backupId);
  }

  public async created(): Promise<void> {
    this.backupId = this.$route.params.backupId;

    await this.fetchBackup();
  }

  public showRestoreDialogFor(data: RestoreBackupDto): void {
    this.isRestoreDialogVisible = true;
    this.restoreDialogData = data;
  }

  public showRestoreGroupDialogFor(data: WebsiteGroupRestoreBackupDtoExtended): void {
    this.isRestoreGroupDialogVisible = true;
    this.restoreGroupDialogData = data;
  }

  public hideRestoreDialog(): void {
    this.isRestoreDialogVisible = false;
    this.restoreDialogData = null;
  }

  public hideRestoreGroupDialog(): void {
    this.isRestoreGroupDialogVisible = false;
    this.restoreGroupDialogData = null;
  }

  public async restoreBackup(backup: RestoreBackupDto): Promise<void> {
    try {
      await this.backupRepository.restoreBackup(backup);

      this.$infoDialog.show('Backup restoration started!');
    } catch (err) {
      await this.onError(err);
    }
  }

  public async restoreGroupBackup(backup: WebsiteGroupRestoreBackupDto): Promise<void> {
    try {
      await this.backupRepository.restoreWebsiteGroupBackup(backup);

      this.$infoDialog.show('Website group restoration started!');
    } catch (err) {
      await this.onError(err);
    }
  }

  private onError(err: unknown): void {
    const asAxiosError = err as AxiosError;
    if (asAxiosError.isAxiosError) {
      this.$errorDialog.show(asAxiosError.response?.data?.message ?? 'An axios error occurred');
    } else if (err instanceof Error) {
      this.$errorDialog.show(err.message);
    } else {
      this.$errorDialog.show('An unknown error occurred');
    }
  }
}
